export default __webpack_public_path__ + "static/media/lugar.284700ba.svg";